import ExamList from './ExamList';

export default ExamList;
